/* unplugin-vue-components disabled */import { render } from "./MainIndex.vue?vue&type=template&id=01e5b5cc&scoped=true"
import script from "./MainIndex.vue?vue&type=script&lang=js"
export * from "./MainIndex.vue?vue&type=script&lang=js"

import "./MainIndex.vue?vue&type=style&index=0&id=01e5b5cc&scoped=true&lang=css"

import exportComponent from "E:\\myprogram\\52haoma_new\\new-haoma52\\haoma52-index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e5b5cc"]])

export default __exports__